<template>
  <div>
    <baseEdit status="create" />
  </div>
</template>

<script>
  import baseEdit from './projectBaseEdit';

  export default {
    name: 'projectAdd',
    components: {
      baseEdit,
    },
  };
</script>
